import { render } from "./RegisterButton.vue?vue&type=template&id=290c761d&scoped=true"
import script from "./RegisterButton.vue?vue&type=script&lang=js"
export * from "./RegisterButton.vue?vue&type=script&lang=js"

import "./RegisterButton.vue?vue&type=style&index=0&id=290c761d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290c761d"]])

export default __exports__